import { createSelector } from 'reselect'

const getLessonsPicker = state => state.lessonsPicker
const getLibrary = state => state.libraries

const privateLibraryLessonsPickerModalSelector = createSelector(
	[ getLessonsPicker, getLibrary ],
	(lessons_picker, libraries) => ({
		entityUID: libraries.current.libraryUID,
		page: lessons_picker.page,
		search: lessons_picker.search,
		order_field: lessons_picker.order_field,
		order_type: lessons_picker.order_type,
		more: lessons_picker.more,
		folderUID: libraries.current.folderUID,
	})
)

export default privateLibraryLessonsPickerModalSelector
